import React, { useEffect } from 'react';
import { useModal } from 'react-modal-hook';
import { PropertyShellModal } from './PropertyShellModal';

interface IPropertyShellModalLauncherProps
	extends React.HTMLAttributes<HTMLDivElement> {
	isModalOpen?: boolean;
}

export const PropertyShellModalLauncher: React.FC<
	IPropertyShellModalLauncherProps
> = ({ isModalOpen, ...props }) => {
	const [showModal] = usePropertyShellModal(isModalOpen);
	return (
		<div {...props} onClick={() => showModal()}>
			{props.children}
		</div>
	);
};

export const usePropertyShellModal = (isModalOpen?: boolean) => {
	const [showModal, hideModal] = useModal(() => {
		return <PropertyShellModal onRequestClose={hideModal} />;
	});

	useEffect(() => {
		if (isModalOpen === true) {
			showModal();
		}
	}, [isModalOpen, showModal]);

	return [showModal, hideModal];
};
